import type React from 'react'
import { cn } from '../../lib/utils'

const badgeClass = {
  success: 'mg-badge mg-badge-success',
  warning: 'mg-badge mg-badge-warning',
  danger: 'mg-badge mg-badge-danger',
  info: 'mg-badge mg-badge-info',
  neutral: 'mg-badge mg-badge-neutral',
} as const

export function Badge({ variant, children }: { variant: keyof typeof badgeClass; children: React.ReactNode }) {
  return <span className={badgeClass[variant]}>{children}</span>
}

export function Button({
  variant = 'primary',
  size = 'md',
  className,
  children,
  loading,
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger'
  size?: 'sm' | 'md'
  loading?: boolean
}) {
  const base = 'inline-flex items-center justify-center gap-2 font-medium transition-colors disabled:opacity-50'
  const v = {
    primary: 'mg-btn-primary',
    secondary: 'mg-btn-secondary',
    ghost: 'h-8 px-2 text-sm text-mg-muted hover:bg-mg-accent-soft hover:text-mg-accent rounded',
    danger: 'h-8 px-3 text-sm rounded bg-[var(--mg-danger)] text-white hover:opacity-90',
  }
  const s = size === 'sm' ? 'h-7 px-2.5 text-xs' : ''
  return (
    <button
      className={cn(base, v[variant], variant !== 'primary' && variant !== 'secondary' ? s : '', className)}
      disabled={props.disabled || loading}
      {...props}
    >
      {loading && (
        <span
          className="inline-block h-3.5 w-3.5 animate-spin rounded-full border-2 border-current border-t-transparent"
          aria-hidden
        />
      )}
      {children}
    </button>
  )
}

export function Input({ className, ...props }: React.InputHTMLAttributes<HTMLInputElement>) {
  return <input className={cn('mg-input', className)} {...props} />
}

export function Select({ className, children, ...props }: React.SelectHTMLAttributes<HTMLSelectElement>) {
  return (
    <select className={cn('mg-input', className)} {...props}>
      {children}
    </select>
  )
}
